import { useEffect, useState } from 'react';
import { isAdminApp } from '~/public/lib/PageHelpers.js';
import { formatCurrency, getCurrencySymbol } from '~/lib/CurrencyHelpers.js';
import QuestionLabel from './QuestionLabel';

const VariablePaymentQuestion = ({ label, value, setValue, settings }) => {
    const defaultAmount = parseFloat(settings?.defaultAmount) || 0;
    const minAmount = parseFloat(settings?.minAmount) || 0;
    const maxAmount = parseFloat(settings?.maxAmount) || 100;
    const incomingAmount = parseFloat(value?.addons?.[0]?.addon?.price);
    const resolvedAmount = Number.isFinite(incomingAmount)
        ? incomingAmount
        : defaultAmount;

    const [sliderValue, setSliderValue] = useState(resolvedAmount);

    useEffect(() => {
        setSliderValue(resolvedAmount);
    }, [resolvedAmount]);

    useEffect(() => {
        setValue({
            addons: [
                {
                    addon: {
                        name: label,
                        price: sliderValue,
                    },
                    quantity: 1,
                },
            ],
            oncePerTransaction: true,
            noSkip: true,
        });
    }, [sliderValue, label]);

    function handleSliderChange(e) {
        const newValue = parseFloat(e.target.value);
        setSliderValue(newValue);
    }


    return (
        <div className="max-w-[320px]">
            <div className="">
                <QuestionLabel label={label} settings={settings} />
                <label className="inline-flex items-center gap-0 rounded-lg border border-gray-300">
                    <span className="pl-3 text-lg font-semibold text-gray-500 select-none">
                        {getCurrencySymbol()}
                    </span>
                    <input
                        type="number"
                        value={sliderValue}
                        onChange={e => {
                            const v = parseFloat(e.target.value);
                            if (!isNaN(v)) setSliderValue(v);
                        }}
                        onBlur={() => {
                            setSliderValue(Math.min(maxAmount, Math.max(minAmount, sliderValue)));
                        }}
                        style={{ width: `calc(${String(sliderValue).length + 1}ch + 0.75rem)` }}
                        className="pr-3 pl-1 text-lg font-semibold bg-transparent outline-none !border-0 [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                        min={minAmount}
                        max={maxAmount}
                        step={1}
                    />
                    </label>
            </div>
            <div className="relative">
                <input
                    type="range"
                    min={minAmount}
                    max={maxAmount}
                    step={1}
                    value={sliderValue}
                    onChange={handleSliderChange}
                    className="w-full h-2 rounded-lg cursor-pointer themed-slider"
                    style={{
                        '--slider-progress': `${(maxAmount > minAmount) ? ((sliderValue - minAmount) / (maxAmount - minAmount)) * 100 : 0}%`,
                    }}
                />
            </div>
            <div className="flex justify-between mt-1 text-sm text-gray-500">
                <span>{formatCurrency(minAmount)}</span>
                <span>{formatCurrency(defaultAmount)}</span>
                <span>{formatCurrency(maxAmount)}</span>
            </div>
        </div>
    );
};

export default VariablePaymentQuestion;

